import { handleSessionStorage, handleTimeLocalStorage } from "@/utils";
import { initConnect, handleSendMessage } from "@/utils/websorket";
import * as calcFunc from "@/utils/calcFunc";
import Vue from "vue";
function isObjectEqual(obj1, obj2) {
  const obj1Keys = obj1 ? Object.keys(obj1) : [];
  const obj2Keys = obj2 ? Object.keys(obj2) : [];

  if (obj1Keys.length !== obj2Keys.length) {
    return false;
  }

  for (let key of obj1Keys) {
    if (!objectsArraysAreEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}
function objectsArraysAreEqual(arr1, arr2) {
  // 检查数组长度
  if (arr1.length !== arr2.length) return false;

  // 遍历数组元素
  for (let i = 0; i < arr1.length; i++) {
    // 检查当前元素是否为对象
    if (typeof arr1[i] !== "object" || typeof arr2[i] !== "object") {
      return false;
    }

    // 遍历对象的属性
    const keys1 = Object.keys(arr1[i]);
    const keys2 = Object.keys(arr2[i]);
    if (keys1.length !== keys2.length) return false;

    for (let j = 0; j < keys1.length; j++) {
      if (arr1[i][keys1[j]] !== arr2[i][keys1[j]]) {
        return false;
      }
    }
  }

  return true;
}

export default {
  namespaced: true,
  state: {
    // carGoodsList:[]
    carGoodsList: {
      // "1":{
      //   "name":"我的",
      //   "list":[],
      //   "smallPrice":0
      // }
    },
  },
  getters: {
    allPrice(state) {
      let all_price = 0;
      for (let userId in state.carGoodsList) {
        const nowList = state.carGoodsList[userId].list;
        let small_price = 0;
        let small_num = 0;
        nowList.forEach((item) => {
          // if(item.UseMemberPrice)//此处需添加是否按会员价算价格
          // all_price+=item.num*item.Price
          all_price = calcFunc.add(
            all_price,
            calcFunc.multiply(item.num, item.Price)
          );
          // small_price+=item.num*item.Price
          small_price = calcFunc.add(
            small_price,
            calcFunc.multiply(item.num, item.Price)
          );
          small_num += item.num;
        });
        // state.carGoodsList[userId].smallPrice=small_price.toFixed(2)-0
        state.carGoodsList[userId].smallPrice = small_price - 0;
        state.carGoodsList[userId].smallNum = small_num;
      }
      return all_price - 0;
    },
    allNum(state) {
      let all_num = 0;
      for (let userId in state.carGoodsList) {
        const nowList = state.carGoodsList[userId].list;
        nowList.forEach((item) => {
          all_num += item.num;
        });
      }
      return all_num;
    },
    allCarGoodsArr(state) {
      let goodsArr = [];
      for (let userId in state.carGoodsList) {
        const nowList = state.carGoodsList[userId].list;
        nowList.forEach((item) => {
          goodsArr.push(item);
        });
      }
      return goodsArr;
    },
  },
  mutations: {
    initCardList(state, data) {
      const goodsArr = [];
      data.forEach((item) => {
        item.MethodName = item.DoWay || "";
        let tasteObj = {};
        if (item.Taste) {
          const tasteArr = item.Taste.split(",");
          tasteArr.forEach((tItem) => {
            tasteObj[tItem] = tItem;
          });
        }
        item.Name = item.Specification || "";
        let RemarkStr = item.Name || "";
        let tasteStr = Object.keys(tasteObj).join(" ");
        RemarkStr = item.MethodName
          ? RemarkStr + " " + item.MethodName
          : RemarkStr;
        RemarkStr = tasteStr ? RemarkStr + " " + tasteStr : RemarkStr;

        item.Remark = RemarkStr;
        item.MethodsAndTasteStr = tasteStr + item.MethodName;
        item.TasteNameObj = tasteObj;
        goodsArr.push({
          ...item,
          num: item.Quantity,
        });
      });
      state.carGoodsList = {
        1: {
          name: "我",
          list: goodsArr,
          smallPrice: 0,
        },
      };
    },
    addCount(state, data) {
      const { userInfo, stepNum } = data;
      const item = $pub.deepClone(data.item);

      // 处理备注
      let RemarkStr = item.Name || "";
      let tasteStr = item.TasteNameObj
        ? Object.keys(item.TasteNameObj).sort().join(" ")
        : "";
      RemarkStr = item.MethodName
        ? RemarkStr + " " + item.MethodName
        : RemarkStr;
      RemarkStr = tasteStr ? RemarkStr + " " + tasteStr : RemarkStr;
      RemarkStr = item.CustomRemark
        ? RemarkStr
          ? RemarkStr + " " + item.CustomRemark
          : item.CustomRemark
        : RemarkStr;
      item.Remark = RemarkStr;
      item.remark = item.remark || item.CustomRemark || "";
      item.MethodsAndTasteStr =
        (tasteStr || "") + (item.MethodName || "") + (item.CustomRemark || "");
      if (!state.carGoodsList[userInfo.userId]) {
        //某一人还未添加时

        Vue.set(state.carGoodsList, userInfo.userId, {
          name: userInfo.name,
          list: [item],
          smallPrice: 0,
        });
      } else {
        let nowUserList = state.carGoodsList[userInfo.userId].list;
        const goodsIndex = nowUserList.findIndex((goodsItem) => {
          if (item.IsServiceId == 6 && goodsItem.Id == item.Id) {
            let isSeemMeal = isObjectEqual(
              item.selectGoodsObj,
              goodsItem.selectGoodsObj
            );
            console.log(isSeemMeal);
            return goodsItem.Id == item.Id && isSeemMeal;
          } else if (item.IsMultiSpecific) {
            if (item.MethodsAndTasteStr.length > 0) {
              return (
                goodsItem.Id == item.Id &&
                goodsItem.SpecificId == item.SpecificId &&
                goodsItem.MethodsAndTasteStr == item.MethodsAndTasteStr
              );
            } else {
              return (
                goodsItem.Id == item.Id &&
                goodsItem.SpecificId == item.SpecificId &&
                (goodsItem.CustomRemark || "") == (item.CustomRemark || "")
              );
            }
          } else {
            if (item.MethodsAndTasteStr.length > 0) {
              return (
                goodsItem.Id == item.Id &&
                goodsItem.MethodsAndTasteStr == item.MethodsAndTasteStr
              );
            } else {
              return (
                goodsItem.Id == item.Id &&
                (goodsItem.CustomRemark || "") == (item.CustomRemark || "")
              );
            }
          }
        });
        if (goodsIndex != -1) {
          console.log("点了之前有的餐品");
          nowUserList[goodsIndex].num += stepNum;
        } else {
          console.log("点了没有的餐品");
          console.log(item);
          if (item.IsServiceId == 6) {
            nowUserList.push({ ...item, num: 1 });
          } else {
            nowUserList.push(item);
          }
        }
      }
      // handleTimeLocalStorage.set('carGoodsList',state.carGoodsList)
    },
    minusCount(state, data) {
      const { userInfo, stepNum, callback } = data;
      const item = $pub.deepClone(data.item);
      let tasteStr = item.TasteNameObj
        ? Object.keys(item.TasteNameObj).sort().join(" ")
        : "";
      item.MethodsAndTasteStr =
        (tasteStr || "") + (item.MethodName || "") + (item.CustomRemark || "");
      if (state.carGoodsList[userInfo.userId]) {
        //某人已经添加时
        let nowUserList = state.carGoodsList[userInfo.userId].list;
        const goodsIndex = nowUserList.findIndex((goodsItem) => {
          if (item.IsServiceId == 6 && goodsItem.Id == item.Id) {
            let isSeemMeal = isObjectEqual(
              item.selectGoodsObj,
              goodsItem.selectGoodsObj
            );
            console.log(isSeemMeal);
            return goodsItem.Id == item.Id && isSeemMeal;
          } else if (item.IsMultiSpecific) {
            if (item.MethodsAndTasteStr.length > 0) {
              return (
                goodsItem.Id == item.Id &&
                goodsItem.SpecificId == item.SpecificId &&
                goodsItem.MethodsAndTasteStr == item.MethodsAndTasteStr
              );
            } else {
              return (
                goodsItem.Id == item.Id &&
                goodsItem.SpecificId == item.SpecificId &&
                (goodsItem.CustomRemark || "") == (item.CustomRemark || "")
              );
            }
            // return goodsItem.Id==item.Id&&goodsItem.SpecificId==item.SpecificId
          } else {
            if (item.MethodsAndTasteStr.length > 0) {
              return (
                goodsItem.Id == item.Id &&
                goodsItem.MethodsAndTasteStr == item.MethodsAndTasteStr
              );
            } else {
              return (
                goodsItem.Id == item.Id &&
                (goodsItem.CustomRemark || "") == (item.CustomRemark || "")
              );
            }
            // return goodsItem.Id==item.Id
          }
        });
        console.log(goodsIndex);
        if (goodsIndex == -1) {
          return;
        }

        console.log("减少时购物车中数量：" + nowUserList[goodsIndex].num);
        if (nowUserList[goodsIndex].num - stepNum > 0) {
          nowUserList[goodsIndex].num -= stepNum;
        } else {
          nowUserList.splice(goodsIndex, 1);
          // 当前人添加的菜品条数变成0时，删除购物车中当前人的展示，若购物车都删除完了，调用回调函数自动将购物车弹窗收起
          if (nowUserList.length == 0) {
            delete state.carGoodsList[userInfo.userId];
          }
          if (Object.keys(state.carGoodsList).length == 0 && callback) {
            callback();
          }
        }
      }
      // handleTimeLocalStorage.set('carGoodsList',state.carGoodsList)
    },
    // 移除购物车中某个商品的某种规格
    removeSpecific(state, data) {
      const { userInfo, stepNum } = data;
      const item = $pub.deepClone(data.item);
      let tasteStr = item.TasteNameObj
        ? Object.keys(item.TasteNameObj).sort().join(" ")
        : "";
      item.MethodsAndTasteStr = tasteStr + item.MethodName;
      if (state.carGoodsList[userInfo.userId]) {
        //某人已经添加时
        let nowUserList = state.carGoodsList[userInfo.userId].list;
        const goodsIndex = nowUserList.findIndex((goodsItem) => {
          if (item.MethodsAndTasteStr.length > 0) {
            return (
              goodsItem.Id == item.Id &&
              goodsItem.SpecificId == item.SpecificId &&
              goodsItem.MethodsAndTasteStr == item.MethodsAndTasteStr
            );
          } else {
            return (
              goodsItem.Id == item.Id && goodsItem.SpecificId == item.SpecificId
            );
          }
          // return goodsItem.Id==item.Id&&goodsItem.SpecificId==item.SpecificId
        });
        if (goodsIndex != -1 && nowUserList[goodsIndex].num <= 0) {
          nowUserList.splice(goodsIndex, 1);
        }
      }
    },
    removeMethod(state, data) {
      const { userInfo, stepNum } = data;
      const item = $pub.deepClone(data.item);
      let tasteStr = item.TasteNameObj
        ? Object.keys(item.TasteNameObj).sort().join(" ")
        : "";
      item.MethodsAndTasteStr = tasteStr + item.MethodName;
      if (state.carGoodsList[userInfo.userId]) {
        //某人已经添加时
        let nowUserList = state.carGoodsList[userInfo.userId].list;
        const goodsIndex = nowUserList.findIndex((goodsItem) => {
          return (
            goodsItem.Id == item.Id &&
            goodsItem.MethodsAndTasteStr == item.MethodsAndTasteStr
          );
        });
        if (goodsIndex != -1 && nowUserList[goodsIndex].num <= 0) {
          nowUserList.splice(goodsIndex, 1);
        }
      }
    },
    // 移除购物车中某个套餐
    removeMealItem(state, data) {
      const { userInfo, stepNum } = data;
      const item = $pub.deepClone(data.item);

      if (state.carGoodsList[userInfo.userId]) {
        //某人已经添加时
        let nowUserList = state.carGoodsList[userInfo.userId].list;
        const goodsIndex = nowUserList.findIndex((goodsItem) => {
          let isSeemMeal = isObjectEqual(
            item.selectGoodsObj,
            goodsItem.selectGoodsObj
          );
          return goodsItem.Id == item.Id && isSeemMeal;
        });
        if (goodsIndex != -1 && nowUserList[goodsIndex].num <= 0) {
          nowUserList.splice(goodsIndex, 1);
        }
      }
    },
    // 移除购物车中某一项
    removeFoodItem(state, data) {
      const { userInfo, idData } = data;
      if (state.carGoodsList[userInfo.userId]) {
        //某人已经添加时
        let nowUserList = state.carGoodsList[userInfo.userId].list;
        const goodsIndex = nowUserList.findIndex((goodsItem) => {
          return goodsItem.Id == idData;
        });
        if (goodsIndex !== -1) {
          nowUserList.splice(goodsIndex, 1);
        }
      }
      // handleTimeLocalStorage.set('carGoodsList',state.carGoodsList)
    },
    clearCartList(state) {
      state.carGoodsList = {};
    },
  },
  actions: {
    ADD_COUNT({ commit }, data) {
      // handleSendMessage('我添加了')
      commit("addCount", data);
    },
    MINUS_COUNT({ commit }, data) {
      // handleSendMessage('我减少了')
      commit("minusCount", data);
    },
    CLEAR_LIST({ commit }) {
      // handleSendMessage('我清除了')
      commit("clearCartList");
    },
  },
};
